
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-800 shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/2543300a-445c-4f27-a4b2-54bc3b47bd9d.png"
              alt="BensonDesigns Logo"
              className="h-10 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Services</a>
            <a href="#portfolio" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Portfolio</a>
            <a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About</a>
            <a href="#testimonials" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Reviews</a>
            <a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</a>
          </nav>

          <div className="hidden md:flex space-x-4">
            <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
              Get Free Quote
            </button>
            <button className="border border-blue-600 text-blue-400 px-6 py-2 rounded-lg hover:bg-blue-600 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Call Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-3">
              <a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Services</a>
              <a href="#portfolio" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Portfolio</a>
              <a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About</a>
              <a href="#testimonials" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Reviews</a>
              <a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</a>
              <div className="flex flex-col space-y-2 mt-4">
                <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                  Get Free Quote
                </button>
                <button className="border border-blue-600 text-blue-400 px-6 py-2 rounded-lg hover:bg-blue-600 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Call Now
                </button>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
